import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useInstance } from 'intact-vue-next';
export function useFilter(rightData) {
  var instance = useInstance();
  instance.on('$receive:value', function (v) {
    if (!Array.isArray(v)) {
      instance.set('value', [], {
        silent: true
      });
    } else {
      var _instance$get = instance.get(),
        keyName = _instance$get.keyName,
        data = _instance$get.data;
      var _data = _filterInstanceProperty(data).call(data, function (item) {
        return ~v.indexOf(item[keyName]);
      });
      rightData.set(_data);
    }
  });
  // only change the left status, reserve the right status
  instance.on('$receive:data', function (v) {
    if (!v || !v.length) {
      instance.set('leftCheckedKeys', []);
    } else {
      var _instance$get2 = instance.get(),
        leftCheckedKeys = _instance$get2.leftCheckedKeys,
        keyName = _instance$get2.keyName;
      var allKeys = v.reduce(function (memo, item) {
        memo[item[keyName]] = true;
        return memo;
      }, {});
      var fix = function fix(keys) {
        var ret = [];
        if (keys) {
          keys.forEach(function (key) {
            if (allKeys[key]) {
              ret.push(key);
            }
          });
        }
        return ret;
      };
      instance.set('leftCheckedKeys', fix(leftCheckedKeys));
    }
  });
  function getFilterData(model) {
    var data;
    if (model === 'left') {
      var _context;
      var _instance$get3 = instance.get(),
        value = _instance$get3.value,
        keyName = _instance$get3.keyName;
      data = _filterInstanceProperty(_context = instance.get('data')).call(_context, function (item) {
        return !~value.indexOf(item[keyName]);
      });
    } else {
      data = rightData.value;
    }
    return data;
  }
  function getShowedData(model) {
    var data = getFilterData(model);
    var keywords = instance.get(model + "Keywords");
    if (instance.get('filterable') && keywords) {
      var filter = instance.get('filter') || defaultFilter;
      data = _filterInstanceProperty(data).call(data, function (item) {
        return filter(item, keywords);
      });
    }
    return data;
  }
  function getEnabledData(model) {
    var _context2;
    return _filterInstanceProperty(_context2 = getShowedData(model)).call(_context2, function (item) {
      return !item.disabled;
    });
  }
  function defaultFilter(data, keywords) {
    var _context3;
    var _instance$get4 = instance.get(),
      labelName = _instance$get4.labelName;
    return _includesInstanceProperty(_context3 = data[labelName]).call(_context3, keywords);
  }
  return {
    getFilterData: getFilterData,
    getShowedData: getShowedData,
    getEnabledData: getEnabledData
  };
}